import {initI18n} from "./i18n";
import {resolveInitialLang} from "./language";

export function bootstrapI18n() {
    const lang = resolveInitialLang();
    initI18n(lang);
}
